import { Component, inject, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { NzSelectModule, } from 'ng-zorro-antd/select';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { PermissionService } from "./../../../core/services/permission.service"
import { PermissionDto } from 'src/app/shared/dto/permission.dto';
import { UserService } from 'src/app/private/services/user.service';
import { UserDto } from 'src/app/shared/dto/user.dto';
import { ProfileDto } from 'src/app/shared/dto/profile.dto';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { ModalAddUserPermissionComponent } from '../../components/modals/modal-add-user-permission/modal-add-user-permission.component';

@Component({
  selector: 'app-permissions',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    NzSpaceModule,
    NzMessageModule,
    NzInputDirective,
    CommonModule,
    FormsModule,
    NzSelectModule,
    NzSwitchModule,
    NzDividerModule,
    NzTableModule,
    NzPageHeaderModule,
    NzButtonModule,
    NzModalModule
  ],
  templateUrl: './permissions.component.html',
  styleUrl: './permissions.component.scss'
})

export class PermissionsComponent {
  private readonly permissionService = inject(PermissionService);
  private readonly userService = inject(UserService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly message = inject(NzMessageService);
  private readonly modalService = inject(NzModalService);
  activeSection: 'usuario' | 'perfil' | 'generales' = 'usuario';
  selectedItem: number | null = null;

  users: {
    id: number;
    nombre: string;
  }[] = [];

  profiles: {
    id: number;
    nombre: string;
  }[] = [];

  permissions: {
    id: number;
    mainkey: string;
    key: string;
    activado: boolean;
    toggleAll: boolean;
    leer: boolean;
    crear: boolean;
    escribir: boolean;
    eliminar: boolean;
  }[] = [];


  async ngOnInit() {
    this.users = [];
    this.profiles = [];
    this.users = this.mapUsers(await this.userService.getUsers());
    const rawProfiles = await this.userService.getProfiles();
    this.profiles = this.mapProfiles(rawProfiles);
    this.cdr.markForCheck();
  }

  async setActive(section: 'usuario' | 'perfil' | 'generales') {
    this.activeSection = section;
    this.selectedItem = null;

    if (section === 'usuario') {
      this.permissions = [];
    }

    if (section === 'perfil') {
      this.permissions = [];
    }

    if (section === 'generales') {
      this.permissions = [];
      const permissionsApp = this.mapPermissions(await this.permissionService.findAllPermisionsApp());
      this.permissions = permissionsApp;


    }
    this.cdr.markForCheck();
  }

  activarTodos() {
    this.permissions.forEach(p => {
      p.activado = p.leer = p.crear = p.escribir = p.eliminar = true;
    });
  }

  desactivarTodos() {
    this.permissions.forEach(p => {
      p.activado = p.leer = p.crear = p.escribir = p.eliminar = false;
    });
  }

  mapPermissions(rawPermissions: any[]): any[] {
    let response = rawPermissions.map(p => {
      const leer = !!p.values.read;
      const crear = !!p.values.create;
      const escribir = !!p.values.edit;
      const eliminar = !!p.values.delete;
      return {
        id: p.id,
        mainkey: p.mainkey,
        key: p.key,
        toggleAll: leer && crear && escribir && eliminar,
        leer,
        crear,
        escribir,
        eliminar
      };
    });
    return response
  }

  mapUsers(rawUsers: UserDto[]): any[] {
    return rawUsers.map(p => {
      return {
        id: p.id,
        nombre: p.name
      };
    });
  }

  mapProfiles(eawProfiles: ProfileDto[]): any[] {
    return eawProfiles.map(p => {
      return {
        id: p.id,
        nombre: p.name
      };
    });
  }

  toggleAll(tipo: 'activado' | 'toggleAll' | 'leer' | 'crear' | 'escribir' | 'eliminar') {
    const activar = !this.permissions.every(p => p[tipo]);
    if (tipo === 'toggleAll') {
      this.permissions = this.permissions.map(p => ({
        ...p,
        toggleAll: activar,
        leer: activar,
        crear: activar,
        escribir: activar,
        eliminar: activar
      }));
    } else {
      this.permissions = this.permissions.map(p => ({
        ...p,
        [tipo]: activar
      }));
    }
  }

  toggleRow(p: any) {
    const activate = p.toggleAll;
    p.leer = activate;
    p.crear = activate;
    p.escribir = activate;
    p.eliminar = activate;
  }

  // permissions.component.ts

  async onSelectionChange(selectedId: number): Promise<void> {
    if (!selectedId) {
      this.permissions = [];
      this.cdr.markForCheck();
      return;
    }

    try {
      console.log(`Cargando permisos para ${this.activeSection} con ID: ${selectedId}`);

      let rawPermissions: PermissionDto[] = [];

      if (this.activeSection === 'usuario') {
        rawPermissions = await this.permissionService.findAllPermisionsUser(selectedId);
      } else {
        rawPermissions = await this.permissionService.findAllPermisionsProfile(selectedId);
      }

      // 3. Mapea los datos y actualiza la propiedad del componente.
      this.permissions = this.mapPermissions(rawPermissions);

    } catch (error) {
      console.error('Error al cargar los permisos:', error);
      this.message.error('No se pudieron cargar los permisos.'); // Usando NzMessageService
      this.permissions = []; // Limpia la tabla en caso de error
    } finally {
      // 4. MUY IMPORTANTE: Notifica a Angular que debe refrescar la vista.
      this.cdr.markForCheck();
    }
  }

  async savePermissions() {
  try {
    const loadingMessageId = this.message.loading('Guardando permisos...', { nzDuration: 0 }).messageId;

    // 2. Ejecutar una acción diferente según la sección.
    switch (this.activeSection) {
      case 'usuario':
        if (!this.selectedItem) {
          this.message.warning('Selecciona un usuario primero.');
          break;
        }
        let permissionsUser: PermissionDto[] = this.permissions.map(p => ({
          id: p.id,
          mainkey: p.mainkey,
          key: p.key,
          values: {
            read: p.leer,
            create: p.crear,
            edit: p.escribir,
            delete: p.eliminar
          }
        }));
        await this.permissionService.updatePermissionsUser(this.selectedItem, permissionsUser);
        break;

      case 'perfil':
        if (!this.selectedItem) {
          this.message.warning('Selecciona un perfil primero.');
          break;
        }
        let permissionsProfile: PermissionDto[] = this.permissions.map(p => ({
          id: p.id,
          mainkey: p.mainkey,
          key: p.key,
          values: {
            read: p.leer,
            create: p.crear,
            edit: p.escribir,
            delete: p.eliminar
          }
        }));
        await this.permissionService.updatePermissionsProfile(this.selectedItem, permissionsProfile);
        break;

      case 'generales':
        let permissionsAPI : PermissionDto[] = this.permissions.map(p => ({
          id: p.id,
          mainkey: p.mainkey,
          key: p.key,
          values: {
            read: p.leer,
            create: p.crear,
            edit: p.escribir,
            delete: p.eliminar
          }
        }));
        await this.permissionService.updatePermissionsApp(permissionsAPI);
        break;
    }

    // 3. Dar feedback de éxito al usuario.
    this.message.remove(loadingMessageId); // Quita el mensaje de "cargando"
    this.message.success('¡Permisos guardados correctamente!');

  } catch (error) {
    console.error('Error al guardar los permisos:', error);
    // En caso de error, también quita el mensaje de carga y muestra uno de error.
    this.message.remove(); 
    this.message.error('No se pudieron guardar los permisos. Inténtalo de nuevo.');
  }
}


  openAddPermissionModal() {
    if (!this.selectedItem) {
      this.message.warning('Selecciona un usuario primero.');
      return;
    }

    const modal = this.modalService.create({
      nzContent: ModalAddUserPermissionComponent,
      nzStyle: { width: '60%', top: '15%' },
      nzBodyStyle: { height: '50vh' },
      nzClosable: false,
      nzFooter: null,
      nzData: {
        nzTitle: 'Añadir permiso de perfil al usuario',
        userId: this.selectedItem,
      }
    });

    modal.componentInstance?.emitService.subscribe(async (permission: PermissionDto) => {
      try {
        await this.permissionService.addUserPermission(this.selectedItem!, permission);

        // Add to the local table with default values (all false)
        this.permissions = [
          ...this.permissions,
          {
            id: permission.id,
            mainkey: permission.mainkey,
            key: permission.key,
            activado: true,
            toggleAll: !!permission.values?.read && !!permission.values?.create && !!permission.values?.edit && !!permission.values?.delete,
            leer: !!permission.values?.read,
            crear: !!permission.values?.create,
            escribir: !!permission.values?.edit,
            eliminar: !!permission.values?.delete,
          }
        ];

        this.message.success(`Permiso "${permission.mainkey} - ${permission.key}" añadido.`);
        this.cdr.markForCheck();
      } catch (e) {
        console.error(e);
        this.message.error('Error al añadir el permiso.');
      }
    });
  }

  async deleteUserPermission(p: any) {
    if (!this.selectedItem) return;

    try {
      await this.permissionService.deleteUserPermission(this.selectedItem, p.id);
      this.permissions = this.permissions.filter(perm => perm.id !== p.id);
      this.message.success(`Permiso "${p.mainkey} - ${p.key}" eliminado.`);
      this.cdr.markForCheck();
    } catch (e) {
      console.error(e);
      this.message.error('Error al eliminar el permiso.');
    }
  }

  async deleteAllUserPermissions() {
    if (!this.selectedItem || this.permissions.length === 0) return;

    try {
      const loadingId = this.message.loading('Eliminando todos los permisos...', { nzDuration: 0 }).messageId;

      for (const p of this.permissions) {
        await this.permissionService.deleteUserPermission(this.selectedItem, p.id);
      }

      this.permissions = [];
      this.message.remove(loadingId);
      this.message.success('Todos los permisos del usuario han sido eliminados.');
      this.cdr.markForCheck();
    } catch (e) {
      console.error(e);
      this.message.remove();
      this.message.error('Error al eliminar los permisos.');
    }
  }
}
